import { FadeUp, scrollToId } from "@/components/motion";
import { Linkedin } from "lucide-react";

// Temporary section: complimentary LinkedIn reviews to build genuine
// recommendations. Remove from Home.jsx once sufficient recommendations exist.
export default function FoundingOffer() {
  return (
    <section data-testid="linkedin-review-offer" className="relative bg-[#0A0A0A] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <FadeUp>
          <div className="border border-[#27272A] p-8 md:p-14 grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <p className="tracking-label text-[11px] uppercase font-body font-bold text-[#DFFF00] mb-5 flex items-center gap-2">
                <Linkedin size={14} /> Limited LinkedIn Profile Review
              </p>
              <h2 className="font-display font-bold tracking-tighter leading-[0.98] text-3xl md:text-5xl text-[#F8F8F5]">
                A complimentary <span className="font-serif-accent font-light">LinkedIn profile review</span> — in exchange for an honest recommendation.
              </h2>
              <p className="mt-6 font-body text-base md:text-lg text-[#A1A1AA] leading-relaxed max-w-xl">
                A limited number of complimentary LinkedIn profile reviews are currently available. You
                receive a clear, practical review of how your profile positions you — headline, About
                section and experience — with specific recommendations. If you believe the work provided
                genuine value, an honest recommendation on LinkedIn is all we ask in return.
              </p>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              <button
                data-testid="linkedin-review-offer-cta"
                onClick={() => scrollToId("#consultation")}
                className="rounded-full bg-[#DFFF00] text-[#0A0A0A] font-body font-semibold px-8 py-4 hover:bg-[#C8E600] transition-colors duration-300"
              >
                Book a consultation
              </button>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
